var _circle, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPsc = function SvgPsc(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 85 85",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 5.715c20.283 0 36.785 16.502 36.785 36.785S62.783 79.285 42.5 79.285 5.715 62.783 5.715 42.5 22.217 5.715 42.5 5.715m0-3.215c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#72a130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.018 35.4c16.325 0 22.537 11.693 22.959 14.274H42.899c-15.925 0-22.214-11.316-22.844-14.127l-.031-.157zM19.935 30.451C23.841 21.907 32.475 15.94 42.5 15.94s18.659 5.967 22.565 14.511zM65.065 54.48c-3.906 8.544-12.54 14.511-22.565 14.511S23.841 63.024 19.935 54.48z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#333092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.789 30.451C12.789 16.089 26.456 5.75 42.5 5.75s29.711 10.339 34.711 24.701h3.439C75.537 14.248 60.392 2.5 42.5 2.5S9.463 14.248 4.351 30.451zM77.235 54.48c-4.98 14.398-18.664 24.77-34.734 24.77S12.747 68.878 7.767 54.48H4.329C9.42 70.719 24.584 82.5 42.502 82.5s33.082-11.782 38.173-28.02h-3.438Z"
  }))));
};
export default SvgPsc;